import { render, staticRenderFns } from "./AlertItem.vue?vue&type=template&id=84a2d4b2&"
import script from "./AlertItem.vue?vue&type=script&lang=js&"
export * from "./AlertItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84a2d4b2')) {
      api.createRecord('84a2d4b2', component.options)
    } else {
      api.reload('84a2d4b2', component.options)
    }
    module.hot.accept("./AlertItem.vue?vue&type=template&id=84a2d4b2&", function () {
      api.rerender('84a2d4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alerts/AlertItem.vue"
export default component.exports